import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onMousedown"]
const _hoisted_2 = ["src"]

import { PropType, computed } from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/styles/ms-select-styles.scss'
import arrow from '@/assets/svg/arrow.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleSelectComponent',
  props: {
  optionsSingle: {
    type: Array<{ value: string; text: string }>,
    required: false
  },
  modelValue: {
    type: Object as PropType<{ value: string; text: string } | null>,
    required: false
  },
  selectText: {
    type: String,
    required: false
  },
  closeOnSelect: {
    type: Boolean,
    required: false,
    default: true
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  width: {
    type: String,
    required: false,
    default: '220px'
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "15697740": (__props.width)
}))

const props = __props

const emits = __emit

const selected = computed({
  get: () => getSelected(),
  set: (val) => updateSelected(val)
})

const updateSelected = (val: { value: string; text: string } | null) => {
  emits('update:modelValue', val)
}

const charLimit = computed(() => parseInt(props.width, 10) / 3)

const getSelected = () => {
  return props.modelValue
}

const formatSelectedValue = (
  selected: { value: string; text: string } | null,
  charLimit: number
) => {
  if (selected === null) {
    return props.selectText || ''
  }

  const text = selected.text

  if (text.length <= charLimit) {
    return text
  }

  return text.slice(0, charLimit - 3) + '...'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Multiselect), {
    class: "ms-dropdown",
    modelValue: selected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    options: __props.optionsSingle,
    multiple: false,
    "close-on-select": __props.closeOnSelect,
    "clear-on-select": false,
    "preserve-search": true,
    placeholder: formatSelectedValue(selected.value, charLimit.value),
    label: "text",
    "track-by": "text",
    deselectLabel: "✓",
    selectedLabel: "✓",
    selectLabel: "",
    disabled: __props.disabled,
    allowEmpty: false,
    "custom-label": (selected) => formatSelectedValue(selected, charLimit.value)
  }, {
    caret: _withCtx(({ toggle }) => [
      _createElementVNode("div", {
        onMousedown: _withModifiers(($event: any) => (toggle()), ["prevent","stop"]),
        class: "multiselect__select"
      }, [
        _createElementVNode("img", {
          src: _unref(arrow),
          class: "icon"
        }, null, 8, _hoisted_2)
      ], 40, _hoisted_1)
    ]),
    noResult: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode(" No elements found. ")
    ])),
    _: 1
  }, 8, ["modelValue", "options", "close-on-select", "placeholder", "disabled", "custom-label"]))
}
}

})